import {HasExtraPrices} from './typings';

export const getMemberPrice = (
  props: HasExtraPrices,
  reference: 'non_member_price' | 'lmg_loyalty' = 'lmg_loyalty',
) => {
  if (props?.extra_prices) {
    return props.extra_prices?.find(
      ({price_level_external_reference}) =>
        price_level_external_reference === reference,
    );
  }

  return undefined;
};
